export const NOTICE_RAIL = 72;
export const NOTICE_MIN = 240;
export const NOTICE_DEFAULT = 300;
export const NOTICE_MAX = 400;
export const NOTICE_EXPAND_AT = 150;

export const ACTION_RAIL = 56;
export const ACTION_MIN = 300;
export const ACTION_DEFAULT = 340;
export const ACTION_MAX = 480;
export const ACTION_EXPAND_AT = 150;

export const ATTENTION_MIN = 420;
export const NOTICE_COLLAPSE_BREAKPOINT = 1200;
export const ACTION_DRAWER_BREAKPOINT = 1000;
/** Card inset in the shell: pl-2 + pr-4. */
const COLUMN_CHROME = 24;

export function clampColumnWidth(px: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, Math.round(px)));
}

/** Live width while the pointer is down. Never flips collapsed. */
export function previewColumnWidth(
  proposed: number,
  collapsed: boolean,
  bounds: { rail: number; min: number; max: number },
): number {
  if (collapsed) return bounds.rail;
  return clampColumnWidth(proposed, bounds.min, bounds.max);
}

export function resolveColumnDrag(
  proposed: number,
  collapsed: boolean,
  width: number,
  bounds: { min: number; max: number; expandAt: number },
): { collapsed: boolean; width: number } {
  const px = Math.round(proposed);
  if (collapsed) {
    if (px > bounds.expandAt) return { collapsed: false, width: bounds.min };
    return { collapsed: true, width };
  }
  if (px <= bounds.expandAt) return { collapsed: true, width };
  return {
    collapsed: false,
    width: clampColumnWidth(px, bounds.min, bounds.max),
  };
}

export interface WorkflowColumns {
  noticeWidth: number;
  noticeCollapsed: boolean;
  actionWidth: number;
}

export function layoutColumns(viewport: number, columns: WorkflowColumns) {
  const noticeCollapsed =
    columns.noticeCollapsed || viewport < NOTICE_COLLAPSE_BREAKPOINT;
  const noticePx = noticeCollapsed ? NOTICE_RAIL : columns.noticeWidth;
  const room = viewport - noticePx - COLUMN_CHROME - ATTENTION_MIN;
  const actionMax = Math.min(ACTION_MAX, Math.max(ACTION_MIN, room));
  return {
    noticeCollapsed,
    noticePx,
    actionOverlay: viewport < ACTION_DRAWER_BREAKPOINT,
    actionMax,
    actionPx: clampColumnWidth(columns.actionWidth, ACTION_MIN, actionMax),
  };
}
